import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
// import { v4 as uuid } from "uuid";
// import firebase from "../../utils/firebaseConfig"
import {
    Avatar,
    Box,
    Button,
    ButtonGroup,
    Chip,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputAdornment,
    MenuItem,
    Radio,
    RadioGroup,
    Rating,
    Step,
    StepButton,
    StepConnector,
    StepLabel,
    Stepper,
    TextField,
} from "@mui/material";

import extraOptionsMenu from "./extraOptionsMenu";

import ratingLabels from "./ratingLabels";

import { editItem } from "../../actions";

import { SnackbarProvider, useSnackbar } from 'notistack';

import StarIcon from '@mui/icons-material/Star';

import tableIcons from "../tableFormatting/tableIcons";

import Default from "../NanoCompTemplates/Default";

import "./styles.css";


const EditAssignments = ({ data, name }) => {

  const location = useLocation();
  const [pageData, setPageData] = useState(location.state);
  const auth = useSelector(state => state.firebase);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const dispatch = useDispatch();

  const [descriptionData, setDescriptionData] = useState(data);
  const [updatedData, setUpdatedData] = useState(pageData);

  const [ratingValue, setRatingValue] = useState(5);
  const [ratingHover, setRatingHover] = useState(-1);

  const assignmentsArray = [];
  const [assignments, setAssignments] = useState(pageData.assignments);
  const [quizNodeAnswers, setQuizNodeAnswers] = useState(pageData.assignments[0].quiz[0].answerOptions);

  const [quizQuestions, setQuizQuestions] = useState(pageData.assignments[0].quiz);
  const [ratingQuestions, setRatingQuestions] = useState(pageData.assignments[0].ratings);

  const [givenAnswer, setGivenAnswer] = useState("");

  const [activeStep, setActiveStep] = useState(0);
  const [activeQuizStep, setActiveQuizStep] = useState(0);
  
  const [activeEssayStep, setActiveEssayStep] = useState(0);
  const [activeRatingStep, setActiveRatingStep] = useState(0);
  const [activeMaterialStep, setActiveMaterialStep] = useState(0);

  const [additionalMaterial, setAdditionalMaterial] = useState(pageData.data[0].additionalMaterials);


  const [editedQuizQuestion,setEditedQuizQuestion] = useState("");

  const [updateValues, setUpdateValues] = useState(false);

  const [image, setImage] = useState("");
  const [link, setLink] = useState("");
  const [linkSplit, setLinkSplit] = useState("");
  const [video, setVideo] = useState("");

  const [selectedPage, setSelectedPage] = useState(0);

  const [quizAnswer, setQuizAnswer] = useState("");
  const [nodeSelection, setNodeSelection] = useState(true);
  const [textSelection, setTextSelection] = useState(false);
  const [ratingSelection, setRatingSelection] = useState(false);

  const [essayQuestionArray, setEssayQuestionArray] = useState(pageData.assignments[0].essay);
  const [essayQuestion, setEssayQuestion] = useState("");
  const [ratingQuestion, setRatingQuestion] = useState("");

  const [selectedDataSet, setSelectedDataSet] = useState(0);
  const [answerType, setAnswerType] = useState(0);

  useEffect(() => {
    if(nodeSelection == true) {
        setTextSelection(false);
        setRatingSelection(false);
    }
    if(textSelection == true) {
        setNodeSelection(false);
        setRatingSelection(false);
    }
    if(ratingSelection == true) {
        setNodeSelection(false);
        setTextSelection(false);
    }
  }, [nodeSelection, textSelection, ratingSelection])

  useEffect(() => {
      
    pageData.assignments.forEach((d, i) => {
        assignmentsArray.push(d);
    })
    setAssignments(assignmentsArray);

  },[auth])


  useEffect(() => {
    setGivenAnswer({name});
      
  }, [name])

  useEffect(() => {
    if(name !== "") {
      setQuizNodeAnswers([...quizNodeAnswers, {index: quizNodeAnswers.length, name: name}])
    }
  }, [name])

  useEffect(() => {
    if(selectedPage < 0) {
        setSelectedPage(0)
    }
  }, [selectedPage]) 

  const handleStep = (step) => () => {
    setQuizQuestions(assignments[step].quiz)
    setEssayQuestionArray(assignments[step].essay)
    setActiveStep(step);

  };


  const handleMaterialStep = (step) => () => {
    setActiveMaterialStep(step);
  };

  const handleQuizStep = (step) => () => {
    setAnswerType(assignments[activeStep].quiz[step].answerType)
    setQuizNodeAnswers(assignments[activeStep].quiz[step].answerOptions)
    setQuizAnswer(assignments[activeStep].quiz[step].answerText)
    setRatingValue(assignments[activeStep].quiz[step].ratingValue)
    setActiveQuizStep(step);
  };
 

  useEffect(() => {
    setQuizNodeAnswers(assignments[activeStep].quiz[activeQuizStep].answerOptions)
  }, [activeQuizStep])

  const handleEssayStep = (step) => () => {
    setActiveEssayStep(step);
  };

  const handleRatingStep = (step) => () => {
    setActiveRatingStep(step);
  };

  function getLabelText(ratingValue) {
    return `${ratingValue} Star${ratingValue !== 1 ? 's' : ''}, ${ratingLabels[ratingValue]}`;
  }

  const [picture, setPicture] = useState(null);
  const [imgData, setImgData] = useState(null);
  const onChangePicture = e => {
    if (e.target.files[0]) {
      setPicture(e.target.files[0]);
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImgData(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleLink = (e) => {
    const linkScrubber = e.split(",")
    setLink(linkScrubber[1])
    const linkScrubber2 = new URL(linkScrubber[1]).host
    setLinkSplit(linkScrubber2)
  }

  const handleNewAssignment = () => {

    setAssignments([...assignments, Default[0].assignments[0]])

    setUpdateValues(true)
  }


  const handleDeleteAssignment = (activeStep) => {
    const updatedItems = assignments && assignments.filter((element , i) => i !== activeStep);
    setAssignments(updatedItems);
    setActiveQuizStep(activeStep - 1)
    setUpdateValues(true)
  }

  const handleNewQuizQuestion = () => {

    quizQuestions.push({ answerOptions: [], answerText: "", questionText: "" })
    
    const addQuestion = assignments.map((d, i) => {
    if(i == activeStep) {
      return {...d, quiz: quizQuestions}
    }
                return d;
  
  })
  setAssignments(addQuestion)
  setUpdateValues(true)

    
  }


  const handleDeleteQuizQuestion = (activeQuizStep) => {
    const updatedItems = quizQuestions && quizQuestions.filter((element , i) => i !== activeQuizStep);
    setQuizQuestions(updatedItems);
    setActiveQuizStep(activeQuizStep - 1)
  }

  const handleNewRatingQuestion = () => {

    ratingQuestions.push({ questionText: "" })
    const addQuestion = assignments.map((d, i) => {
    if(i == activeStep) {
      return {...d, quiz: ratingQuestions}
    }
                return d;
  

  })
  setAssignments(addQuestion)

    
  }


  const handleDeleteRatingQuestion = (activeRatingStep) => {
    const updatedItems = ratingQuestions && ratingQuestions.filter((element , i) => i !== activeRatingStep);
    setRatingQuestions(updatedItems);
    setActiveRatingStep(activeRatingStep - 1)
  }


  const handleChipDelete = (index) => {
    const updatedItems = quizNodeAnswers && quizNodeAnswers.filter((element , i) => i !== index);
    setQuizNodeAnswers(updatedItems);
    setAssignments(assignments)
  }

  const handleQuizQuestion = (item) => {
    setEditedQuizQuestion(item);

    const updatedValues = quizQuestions.map((d, i) => {
      if(i == activeQuizStep) {
        return {...d, questionText: item}
      }
      return d;
    })

    setQuizQuestions(updatedValues)


    const updateAssignments = assignments.map((d, i) => {
      if(i == activeStep) {
        return {...d, quiz: quizQuestions}
      }
      return d;
    })


  }

  useEffect(() => {
    const seen = new Set();
    const filteredArr = quizNodeAnswers.filter(el => {
      const duplicate = seen.has(el.name);
      seen.add(el.name);
      return !duplicate;
    });

      
  const updatedValues = quizQuestions.map((d, i) => {
    if(i == activeQuizStep) {
      if(answerType == 0) {
        return {...d, answerType: answerType, answerOptions: filteredArr}

      }
      if(answerType == 1) {
        return {...d, answerType: answerType, answerText: quizAnswer}
        
      }
      if(answerType == 2) {
        return {...d, answerType: answerType, ratingValue: ratingValue}
      }
    }
    return d;
  })

  setQuizQuestions(updatedValues)

  const updatedAssignments = assignments.map((d, i) => {
    if(i == activeStep) {
      return {...d, quiz: updatedValues}
    }
    return d;

  })
  setUpdatedData({
    assignments: updatedAssignments,
    author: pageData.author,
    data: pageData.data,
    description: pageData.description,
    index: pageData.index,
    isExample: pageData.isExample,
    likes: pageData.likes,
    name: pageData.name,
  })

  setPageData(updatedData)
  setUpdateValues(false);
  },[updateValues])

useEffect(() => {
  if(additionalMaterial == "None") {

    const handleRemoveMaterials = () => {

      const editDescription = descriptionData.map((d, i) => {
        if(activeMaterialStep == d.index) {
          return {...d, additionalMaterial: { link: "", photo: null, video: "" }}
        }
          return d;
      })
    
      setDescriptionData(editDescription)

      setUpdatedData({
        assignments: pageData.assignments,
        author: pageData.author,
        data: editDescription,
        description: pageData.description,
        index: pageData.index,
        isExample: pageData.isExample,
        likes: pageData.likes,
        name: pageData.name,
      })
      setPageData(updatedData)
    }
    handleRemoveMaterials()
  }

}, [additionalMaterial])


const handleParentDescription = (description) => {
  const splitArrayIndexing = description.split(',');
  const arrayIndex = splitArrayIndexing[0];
  const textValues = splitArrayIndexing[1];

  const editDescription = descriptionData.map((d, i) => {
    if(arrayIndex == d.index) {
      return {...d, description: textValues, additionalMaterial: { link: link, photo: imgData, video: video.split(",")[1] }}
    }
      return d;
  })

  setDescriptionData(editDescription)

  setUpdatedData({
    assignments: pageData.assignments,
    author: pageData.author,
    data: editDescription,
    description: pageData.description,
    index: pageData.index,
    isExample: pageData.isExample,
    likes: pageData.likes,
    name: pageData.name,
  })
  setPageData(updatedData)

}


const handleChildDescription = (description) => {
  const splitArrayIndexing = description.split(',');
  const parentArrayIndex = splitArrayIndexing[0];
  const arrayIndex = splitArrayIndexing[1];
  const textValues = splitArrayIndexing[2];

  const editChildren = descriptionData[parentArrayIndex].children.map((d, i) => {
    if(arrayIndex == i) {
      return {...d, description: textValues}
    }
      return d;
  })

  const editDescription = descriptionData.map((d, i) => {
    if(parentArrayIndex == i) {
      return {...d, children: editChildren}
    }
      return d;
  })

  setDescriptionData(editDescription)

  setUpdatedData({
    assignments: pageData.assignments,
    author: pageData.author,
    data: editDescription,
    description: pageData.description,
    index: pageData.index,
    isExample: pageData.isExample,
    likes: pageData.likes,
    name: pageData.name,
  })
  setPageData(updatedData)

}


const handleSubDescription = (description) => {
  const splitArrayIndexing = description.split(',');
  const masterArrayIndex = splitArrayIndexing[0];
  const parentArrayIndex = splitArrayIndexing[1];
  const arrayIndex = splitArrayIndexing[2];
  const textValues = splitArrayIndexing[3];

  const editSub = descriptionData[parentArrayIndex].children[arrayIndex].children.map((d, i) => {
    if(arrayIndex == i) {
      return {...d, description: textValues}
    }
    return d;
  })

  const editChildren = descriptionData[parentArrayIndex].children.map((d, i) => {
    if(arrayIndex == i) {
      return {...d, children: editSub}
    }
      return d;
  })

  const editDescription = descriptionData.map((d, i) => {
    if(parentArrayIndex == i) {
      return {...d, children: editChildren}
    }
      return d;
  })

  setDescriptionData(editDescription)

  setUpdatedData({
    assignments: pageData.assignments,
    author: pageData.author,
    data: editDescription,
    description: pageData.description,
    index: pageData.index,
    isExample: pageData.isExample,
    likes: pageData.likes,
    name: pageData.name,
  })
  setPageData(updatedData)

  }

const handleNewEssayQuestion = () => {

  essayQuestionArray.push({ questionText: "" })
  
 const addEssayQuestion = essayQuestionArray.map((d, i) => {
  if(i == activeStep) {
    return {...d, essay: essayQuestion}
  }
              return d;


})

setEssayQuestionArray(addEssayQuestion)
setUpdateValues(true)

}


const handleDeleteEssayQuestion = (activeEssayStep) => {

  const updatedItems = essayQuestionArray && essayQuestionArray.filter((element , i) => i !== activeEssayStep);
  setEssayQuestionArray(updatedItems);
  setActiveEssayStep(activeEssayStep - 1)
}

const handleEssayQuestions = () => {
  const splitArrayIndexing = essayQuestion.split(',');
  const arrayIndex = splitArrayIndexing[0];
  const textValues = splitArrayIndexing[1];

  const editEssay =  essayQuestionArray.map((d, i) => {

    if(arrayIndex == i) {
      return {...d, questionText: textValues}
    }
    return d;
  })

  setEssayQuestionArray(editEssay)


  const updatedAssignments = assignments.map((d, i) => {
    if(i == activeStep) {
      return {...d, essay: editEssay}
    }
                return d;


  })


  setUpdatedData({
    assignments: updatedAssignments,
    author: pageData.author,
    data: pageData.data,
    description: pageData.description,
    index: pageData.index,
    isExample: pageData.isExample,
    likes: pageData.likes,
    name: pageData.name,
  })

  setPageData(updatedData)

}
const handleRatingQuestions = () => {

  const splitArrayIndexing = ratingQuestion.split(',');
  const arrayIndex = splitArrayIndexing[0];
  const textValues = splitArrayIndexing[1];

  const editRatings =  ratingQuestions.map((d, i) => {

    if(arrayIndex == i) {

      return {...d, questionText: textValues}
    }
    return d;
  })

  setRatingQuestions(editRatings)

  const updatedAssignments = assignments.map((d, i) => {
    if(i == activeStep) {
      return {...d, ratings: editRatings}
    }
                return d;


  })

  setUpdatedData({
    assignments: updatedAssignments,
    author: pageData.author,
    data: pageData.data,
    description: pageData.description,
    index: pageData.index,
    isExample: pageData.isExample,
    likes: pageData.likes,
    name: pageData.name,
  })

  setPageData(updatedData)

}

  const sendValues = () => {

    dispatch(editItem(updatedData));
    // setUpdatedData(true);
    enqueueSnackbar(pageData.name + " successfully updated!", { variant: "success" })
      
       

  setAssignments(pageData.assignments)

 


  }


return (

  <Grid
    container
    spacing={0}
    direction="column"
    alignItems="center"
    justify="center"
    style={{ marginBottom: "30px" }}
  >
    <div style={{ padding: "20px 0 20px 0", textAlign: "center" }}>
      <p>Assignments:</p>

      <Stepper nonLinear activeStep={activeStep} >
        {assignments.map((label, index) => (
          <Step key={index}>
            <StepButton color="inherit" onClick={handleStep(index)}>
            </StepButton>
          </Step>
        ))}
        {assignments.length > 1 && (
          <StepButton icon={<tableIcons.ThirdStateCheck />} onClick={() => handleDeleteAssignment(activeStep)} />
        )}
          <StepButton icon={<tableIcons.AddOutline />} onClick={() => handleNewAssignment()}>      
          </StepButton>
      </Stepper>
    </div>    

    <ButtonGroup disableElevation variant="" color="primary" style={{ margin: "20px 0 20px 0" }}>
    <Button variant={selectedDataSet === 0 ? "contained" : "outlined"} onClick={()=>setSelectedDataSet(0)}>Materials</Button>
    <Button variant={selectedDataSet === 1 ? "contained" : "outlined"} onClick={()=>setSelectedDataSet(1)}>Quiz</Button>
    <Button variant={selectedDataSet === 2 ? "contained" : "outlined"}  onClick={()=>setSelectedDataSet(2)}>Essay</Button>
    <Button variant={selectedDataSet === 3 ? "contained" : "outlined"}  onClick={()=>setSelectedDataSet(3)}>Feedback</Button>
    </ButtonGroup>
                 
             
    {selectedDataSet == 0 ? (
      <>

        <div style={{ padding: "20px 0 20px 0", textAlign: "center" }}>
          <p>Nodes:</p>

          <Stepper nonLinear activeStep={activeMaterialStep} >
            {descriptionData.map((label, index) => (
              <Step key={index}>

                <StepButton color="inherit" onClick={handleMaterialStep(index)}>
                  <StepLabel>{label.name}</StepLabel>
                </StepButton>

              </Step>
            ))}
          </Stepper>
        </div>    

        {descriptionData.map((d, i) => (
          <>
          {activeMaterialStep == i && (
                    
            <>
              <TextField 
                multiline={true} 
                id="outlined-basic" 
                defaultValue={d.description} 
                label={"Parent Node: " + d.name}  
                style={{ 
                  minWidth: "80%", 
                  margin: "20px 0 20px 0" 
                  }} 
                onChange={(e) => handleParentDescription(d.index + "," + e.target.value)} 
              />

                {d.children.map((x, y) => (
                  <>
          
                    <TextField multiline={true} id="outlined-basic" defaultValue={x.description} label={"Child Node: " + x.name} style={{ minWidth: "80%", margin: "20px 0 20px 0" }} onChange={(e) => handleChildDescription(x.parentIndex + "," + x.index + "," + e.target.value)} />
                
                      {x.children.map((a, b) => (
                        <>
                          <TextField multiline={true} id="outlined-basic" defaultValue={a.description} label={"Sub Node: " + a.name} style={{ minWidth: "80%", margin: "20px 0 20px 0" }} onChange={(e) => handleSubDescription(a.masterIndex + "," + a.parentIndex + "," + a.index + "," + e.target.value)}  />
                        </>
                      ))}
                 
                      <TextField
                        id="outlined-select-currency"
                        select
                        label="Additional Materials"
                        defaultValue=""
                        value={additionalMaterial}
                        onChange={(e) => {setAdditionalMaterial(e.target.value)}}
                        // helperText=""
                        style={{ 
                          minWidth: "80%", 
                          margin: "20px 0 20px 0" 
                          }} 
                      >
                        {extraOptionsMenu.map((option) => (
                          <MenuItem key={option.index} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                          
                      {additionalMaterial == "Link" ? (
                        <>
                 
                          {linkSplit != "" ? (
                            <>
                              <Avatar
                                src={"https://" + linkSplit + "/favicon.ico/"}
                              />
                                <p>{linkSplit}</p>
                            </>
                          ) : descriptionData[i].additionalMaterial.link != "" ? (
                            <>
                              <Avatar
                                src={"https://" + new URL(descriptionData[i].additionalMaterial.link).host + "/favicon.ico"}
                              />
                                <p>{new URL(descriptionData[i].additionalMaterial.link).host}</p>
                                <p>{descriptionData[i].additionalMaterial.link}</p>
                            </>
                          ) : (
                            <p>No External Material uploaded</p>
                          )}
                    
                          <TextField 
                            multiline={true} 
                            id="outlined-basic" 
                            style={{ 
                              minWidth: "80%", 
                              margin: "20px 0 20px 0" 
                              }} 
                            onChange={(e) => handleLink(d.index + "," + e.target.value)} 
                      
                          />
                        </>
                      ) : additionalMaterial == "Video" ?  (
                        <>
                            {video != "" ? (
                              <iframe width="560" height="315" src={video.split(",")[1]} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                              ) : descriptionData[i].additionalMaterial.video != "" ? (
                                <>
                                <iframe width="560" height="315" src={descriptionData[i].additionalMaterial.video} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                </>
                              ) : (
                                <p>No Video Material uploaded</p>
                              )}

                            <TextField 
                              multiline={true} 
                              id="outlined-basic" 
                              style={{ 
                                minWidth: "80%", 
                                margin: "20px 0 20px 0" 
                                }} 
                              onChange={(e) => setVideo(d.index + "," + e.target.value)} 
                            />
                        </>
                      ) : additionalMaterial == "Picture" ?  (
                        <>
                          <Button
                            component="label"
                            style={{ display: "flex", justifyContent: "center", paddingTop: "10px" }}
                            >
                            Upload Image
                            <input
                                type="file"
                                className="playerProfilePic_home_title"
                                onChange={onChangePicture}
                                hidden
                            />
                          </Button>
                        
                          {descriptionData[i].additionalMaterial.photo != null ? (
                            <>
                              <div>
                                <img style={{ maxWidth: "40vw", padding: "10px 0 30px 0", display: "block", marginLeft: "auto", marginRight: "auto" }} src={descriptionData[i].additionalMaterial.photo} />
                              </div>
                            </>
                          ) : imgData != "" ? (
                            <div>
                              <img style={{ maxWidth: "40vw", padding: "10px 0 30px 0", display: "block", marginLeft: "auto", marginRight: "auto" }} src={imgData} />
                            </div>
                          ) : (
                            <p>No Picture Material uploaded</p>
                          )}

                        </>
                      ) : additionalMaterial == "None" ? (
                        <>
                          <p>No Additional Material</p>
                        </>
                      ) : (
                        <div></div>
                      )}

                    </>
                    ))}
                  </>
                  )}
                </>
                ))}
              </>
            ) : selectedDataSet == 1 ? (
              <>
                <div style={{ padding: "20px 0 20px 0", textAlign: "center" }}>
                  <p>Question:</p>

                  <Stepper style={{ margin: "20px 0 20px" }} nonLinear activeStep={activeQuizStep} connector={<StepConnector />}>

                    {quizQuestions.map((d, i) => (
                      <Step key={i} >

                        <StepButton color="inherit" onClick={handleQuizStep(i)}>
                          {/* {label} */}
                        </StepButton>

                      </Step>
                    ))}
                    {quizQuestions.length > 1 && (
                      <StepButton icon={<tableIcons.ThirdStateCheck />} onClick={() => handleDeleteQuizQuestion(activeQuizStep)} />

                    )}

                    <StepButton icon={<tableIcons.AddOutline />} onClick={() => handleNewQuizQuestion()}>
                
                    </StepButton>
            
                  </Stepper>
                </div>    
  
             {quizQuestions.map((d, i) => (  
                <>
      
                  {activeQuizStep == i && (

                    <>

                    <TextField 
                      multiline={true} 
                      id="outlined-basic" 
                      value={d.questionText} 
                      label={"Question " + (i + 1)} 
                      style={{ minWidth: "80%", padding: "0 0 0px 0" }} 
                      onChange={(e) => { handleQuizQuestion(e.target.value) }} 
                      InputProps={{
                        endAdornment: <InputAdornment position="end">
                          <IconButton 
                          onClick={() => { setUpdateValues(true) }}>
                          <tableIcons.Check>
                        </tableIcons.Check>
                        </IconButton>
                      </InputAdornment> 
                        }}
                    />


                    <FormControl style={{ margin: "40px 0 40px" }}>

                      <RadioGroup
                        row
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={answerType}
                        // onChange={handleChange}
                      >
                        <FormControlLabel value={0} control={<Radio />} onClick={() => setAnswerType(0)} label="Node Selection" />
                        <FormControlLabel value={1} control={<Radio />} onClick={() => setAnswerType(1)} label="Text Input" />
                        <FormControlLabel value={2} control={<Radio />} onClick={() => setAnswerType(2)} label="Rating Input" />
                      </RadioGroup>
                    </FormControl>

                    {answerType == 0 ? (
                      <>

                        <TextField multiline={true} id="outlined-basic" 
                          InputProps={{
                            onKeyDown: (event) => {
                              event.preventDefault();
                          },
                          startAdornment: quizNodeAnswers.map((d, index) => (
                            <Chip
                              key={index}
                              // tabIndex={-1}
                              label={d.name}
                              color="info"
                              // variant="outlined"
                              // onDelete={handleChipDelete(index)}
                              onDelete={() => handleChipDelete(index)}
                              // className={classes.chip}
                              // onDelete={handleChipDelete(d)}
                            />
                          )),
                          endAdornment: <InputAdornment position="end">
                              <IconButton 
                              onClick={() => { setUpdateValues(true) }}>
                              <tableIcons.Check>
                            </tableIcons.Check>
                            </IconButton>
                          </InputAdornment> 
                            }}
                            // label={"Answer " + (i + 1)} style={{ minWidth: "80%", padding: "0 0 40px 0" }} onChange={(e) => { handleQuizNodes(e.target.value)}}>
                            label={"Answer " + (i + 1)} style={{ minWidth: "80%", padding: "0 0 40px 0" }}>
                          </TextField>

                      </>
                ) : answerType == 1 ? (
                  <TextField 
                    multiline={true} 
                    id="outlined-basic" 
                    label={"Answer " + (i + 1)} 
                    defaultValue={assignments[activeStep].quiz[activeQuizStep].answerText} 
                    style={{ minWidth: "80%", padding: "0 0 40px 0" }} 
                    onChange={(e) => { setQuizAnswer(e.target.value) }}
                    InputProps={{
                    endAdornment: <InputAdornment position="end">
                        <IconButton 
                          onClick={() => { setUpdateValues(true) }}>
                        <tableIcons.Check>
                        </tableIcons.Check>
                      </IconButton>
                    </InputAdornment> 
                    }}
                  />
                ) : answerType == 2 ? (
                  <div style={{ textAlign: "center", margin: "0 0 30px 0" }}>
              
                    <Rating
                      name="hover-feedback"
                      value={ratingValue}
                      precision={1}
                      getLabelText={getLabelText}
                      onChange={(event, newValue) => {
                        setRatingValue(newValue);
                      }}
                      max={10}
                      onChangeActive={(event, newHover) => {
                        setRatingHover(newHover);
                      }}
                      emptyIcon={<StarIcon style={{ opacity: 0.55, marginBottom: "22px" }} fontSize="inherit" />}
                    />
                    {ratingValue !== null && (
                      <Box sx={{ ml: 2 }}>{ratingLabels[ratingHover !== -1 ? ratingHover : ratingValue]}</Box>
                    )}
                          
                  </div>
                ) : (
                  <>
                    {setAnswerType(0)}
                  </>
                )}
                
              </>

        
            )}
          </>
        ))}
               

      </>
    ) : selectedDataSet == 2 ? (
      <>
              
        <div style={{ padding: "20px 0 20px 0", textAlign: "center" }}>
          <p>Essay Material:</p>

          <Stepper style={{ margin: "20px 0 20px" }} nonLinear activeStep={activeEssayStep} connector={<StepConnector />}>

            {essayQuestionArray.map((d, i) => (
              <Step key={i} >

                <StepButton color="inherit" onClick={handleEssayStep(i)}>
                  {/* {label} */}
                </StepButton>

              </Step>
            ))}
            {essayQuestionArray.length > 1 && (
              <StepButton icon={<tableIcons.ThirdStateCheck />} onClick={() => handleDeleteEssayQuestion(activeEssayStep)} />

            )}
                    
              

            <StepButton icon={<tableIcons.AddOutline />} onClick={() => handleNewEssayQuestion()}>
                
            </StepButton>
            
          </Stepper>
        </div>    
      {essayQuestionArray.map((d, i) => (
        <>

          {activeEssayStep == i && (
            <>


              <TextField 
                multiline={true} 
                id="outlined-basic" 
                defaultValue={d.questionText} 
                label={"Task " + (i + 1)} 
                style={{ 
                  minWidth: "80%", 
                  padding: "0 0 40px 0" 
                  }} 
                onChange={(e) => { setEssayQuestion(i + "," + e.target.value) }}
                InputProps={{
                  endAdornment: <InputAdornment position="end">
                      <IconButton 
                        onClick={(e) => { handleEssayQuestions() }}>
                        <tableIcons.Check>
                      </tableIcons.Check>
                      </IconButton>
                    </InputAdornment> 
                  }}
              />
            </>
          )}
        </>
        ))}

      </>

    ) : (
        <>

          <div style={{ padding: "20px 0 20px 0", textAlign: "center" }}>
            <p>Ratings:</p>

              <Stepper style={{ margin: "20px 0 20px" }} nonLinear activeStep={activeRatingStep} connector={<StepConnector />}>

                {ratingQuestions.map((d, i) => (
                  <Step key={i} >

                    <StepButton color="inherit" onClick={handleRatingStep(i)}>
          
                    </StepButton>

                  </Step>
                ))}
                {ratingQuestions.length > 1 && (
                  <StepButton icon={<tableIcons.ThirdStateCheck />} onClick={() => handleDeleteRatingQuestion(activeRatingStep)} />

                )}
                
              

                <StepButton icon={<tableIcons.AddOutline />} onClick={() => handleNewRatingQuestion()}>
                
                </StepButton>
            
              </Stepper>
            </div>  

          {ratingQuestions.map((d, i) => (
            <>
            {activeRatingStep == i && (
            <TextField 
              multiline={true} 
              id="outlined-basic" 
              defaultValue={d.questionText} 
              label={"Feedback " + (i + 1)} 
              style={{ 
                minWidth: "80%", 
                padding: "0 0 40px 0" 
              }} 
              onChange={(e) => { setRatingQuestion(i + "," + e.target.value) }}
              InputProps={{
                endAdornment: <InputAdornment position="end">
                    <IconButton 
                      onClick={(e) => { handleRatingQuestions() }}>
                      <tableIcons.Check>
                    </tableIcons.Check>
                    </IconButton>
                  </InputAdornment> 
                }}
            />
          )}
 
        </>
      ))}
    </>
  )}
    <Button variant="outlined" style={{ marginTop: "40px" }} onClick={() => sendValues()}>Publish all changes</Button>

  </Grid>      
                 
)
};


export default EditAssignments;